module.exports = __webpack_public_path__ + "static/media/logo-large.18aed477.png";